<table class="table table-sm">
    <tbody>
        <tr *ngFor="let priceList of event.priceLists">
            <td>{{priceList.name}}</td>
            <td>{{priceList.createdAt | date: 'dd-MM-yyyy'}}</td>
            <td class="text-right">
                <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                    <app-price-list-preview-modal [priceListId]="priceList.id"></app-price-list-preview-modal>
                    &nbsp;
                    <button [hidden]="eventFinished" type="button" class="btn btn-sm btn-default"
                        (click)="assignPriceListToEventClick(priceList.id)" style="height: 32px;">Assign</button>
                    &nbsp;
                    <button [hidden]="eventFinished" type="button" class="btn btn-sm btn-danger"
                        (click)="unassignPriceListEventClick(priceList.id.toString())" style="height: 32px;">Remove</button>
                    &nbsp;
                </div>
            </td>
        </tr>
    </tbody>
</table>
<div class="card" [hidden]="eventFinished">
    <div class="card-body" style="padding-bottom: 0px;">
        <div class="form-row align-items-center">
            <div class="col-6">
                <app-select label="Price List" [options]="unusedPriceListOptions" [(model)]="priceListId"
                    (modelChange)="priceListSelectChange()"></app-select>
            </div>
            <div class="col-6">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-sm btn-primary" [disabled]="disableSelectPriceListButton"
                        (click)="assignPriceListToEventClick(0)">Select</button>
                    <app-price-list-preview-modal [priceListId]="priceListId"
                        [disabled]="disableDetailsPriceListButton">
                    </app-price-list-preview-modal>
                    <!--<button type="button" class="btn btn-sm btn-primary">Choose Old</button>-->
                </div>
            </div>
        </div>
    </div>
</div>
